module.exports = __webpack_public_path__ + "img/Wix_Pin_Screen.76139341.png";